import React from 'react';

const NotFound = () => {
    return (
        <div>お探しのページは見つかりませんでした。</div>
    )
}

export default NotFound;